module.exports = __webpack_public_path__ + "img/in-bg-Crime-scene.6991f092.png";